import Model from "@/lib/model/model";
import request from "@/lib/request/request";

// 表头定义
export class Header extends Model {
  headerInExcel = ""; // excel中表头(可能重复)
  headerInSql = ""; // sql中表头(不重复)
  group = ""; // 分类
  on = false; // 是否选中
}

// 候选人基本信息导出请求参数
export interface NewTaskCandReq {
  // 筛选条件
  examType?: string;
  examId?: number;
  examVersionId?: number;
  subExamId?: number;
  candidateIdList?: number[];
  connectCodeList?: string[];
  searchKeyLike?: string;
  showNameOrPhone?: string;
  phone?: string;
  positionId?: number;
  tagNameList?: string[];
  aiRecommendStatusList?: number[];
  submitStatusList?: number[];
  auditStatusList?: number[];
  searchUserIdList?: number[];
  createdTime?: [string, string];
  beginTime?: [string, string];
  submitTime?: [string, string];
  paramSearchList?: [string, string][];
  candidateIdLe?: number;
  afterBuy?: number;
  outLinkStatusList?: number[];
  markCallbackStatusList?: number[];

  // 导出配置
  execType: number; // 请求类型 0:发起导出任务 1:同步返回全量表头
  taskName?: string; // 任务名
  headersInSql?: string[]; // 导出表头过滤
  suffix?: string; // 文件后缀 xlsx/csv
}

// 候选人基本信息导出响应
export class NewTaskCandRes extends Model {
  exportId = 0; // 导出任务id
  headers: Header[] = [new Header()]; // 全量表头
}

// 候选人答案导出请求参数
export interface NewTaskCandAnsReq {
  // 筛选条件
  examType?: string;
  examId?: number;
  examVersionId?: number;
  subExamId?: number;
  candidateIdList?: number[];
  connectCodeList?: string[];
  searchKeyLike?: string;
  showNameOrPhone?: string;
  phone?: string;
  positionId?: number;
  tagNameList?: string[];
  aiRecommendStatusList?: number[];
  submitStatusList?: number[];
  auditStatusList?: number[];
  searchUserIdList?: number[];
  createdTime?: [string, string];
  beginTime?: [string, string];
  submitTime?: [string, string];
  paramSearchList?: [string, string][];
  candidateIdLe?: number;
  afterBuy?: number;
  outLinkStatusList?: number[];
  markCallbackStatusList?: number[];

  // 导出筛选
  questionTypeList?: number[]; // 题型筛选 6:视频题 7:选择题 5:填空题
  maxAskAppendRound?: number; // 最大追问轮数

  // 导出配置
  execType: number; // 请求类型 0:发起导出任务 1:同步返回全量表头
  taskName?: string; // 任务名
  headersInSql?: string[]; // 导出表头过滤
  suffix?: string; // 文件后缀 xlsx/csv
}

// 候选人答案导出响应
export class NewTaskCandAnsRes extends Model {
  exportId = 0; // 导出任务id
  headers: Header[] = [new Header()]; // 全量表头
}

// 导出API类
export class ExportApi extends Model {
  // 候选人基本信息导出
  static newTaskCand(params: NewTaskCandReq) {
    return request.post("/v2/aiExam/export/newTask/cand", params).then(res => {
      console.log("API响应数据结构:", res.data);

      // 尝试两种路径，先试 res.data.data，再试 res.data
      const responseData = res.data.data || res.data;
      console.log("使用的响应数据:", responseData);

      const result = new NewTaskCandRes().assign(responseData);
      console.log("assign后的结果:", result);
      console.log("最终结果 - headers数量:", result.headers?.length || 0);
      console.log("headers内容:", result.headers);
      return result;
    });
  }

  // 候选人答案导出
  static newTaskCandAns(params: NewTaskCandAnsReq) {
    return request
      .post("/v2/aiExam/export/newTask/candAns", params)
      .then(res => {
        // 尝试两种路径，先试 res.data.data，再试 res.data
        const responseData = res.data.data || res.data;
        const result = new NewTaskCandAnsRes().assign(responseData);
        return result;
      });
  }
}
